module.exports = __webpack_public_path__ + "img/icon-games.810ab44d.svg";